import React from 'react';

function BookButton({ text, onClick }) {
  return (
    <button
      onClick={onClick}
      className="px-8 py-4 bg-[#FFD82D] text-[#162E3B] font-extrabold text-base rounded-xl shadow-md border-2 border-transparent hover:bg-white hover:border-[#FFD82D] hover:text-black focus:outline-none focus:ring-4 focus:ring-[#FFD82D] active:scale-98 transition-all duration-200 w-full sm:w-60 h-16 flex justify-center items-center"
    >
      {text}
    </button>
  );
}

export default BookButton;
